import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';
import Translate from './Translate';
import { Theme } from '../models/Theme';

// Define Styled components for the 6 levels of <h#> tags
const hTags = {};
for (let i = 1; i <= 6; i++) {
    const tag = `h${i}`;
    if (!hTags[tag]) {
        hTags[tag] = styled<any, any>(tag)`
            ${propStyles}
        `;
    }
}

interface HTagProps {
    theme?: Theme;
    componentTheme?: string;
    defaultStyleProps?: Theme;
    text?: string;
    level: number;
    id?: string;
}

class HTag extends React.Component<HTagProps> {
    get componentTheme() {
        const { theme, componentTheme, defaultStyleProps } = this.props;
        let baseTheme =
            (theme && componentTheme && theme[componentTheme]) || {};
        if (!isNullOrEmpty(defaultStyleProps)) {
            baseTheme = { ...defaultStyleProps, ...baseTheme };
        }
        return baseTheme;
    }

    render() {
        const { text, level = 2, id } = this.props;

        if (isNullOrEmpty(text)) {
            return null;
        }

        const Tag = hTags[`h${level}`];

        return (
            <Tag id={id} {...this.componentTheme}>
                <Translate>{text}</Translate>
            </Tag>
        );
    }
}

export default withTheme(HTag) as any;



// WEBPACK FOOTER //
// ./src/Components/HTag.tsx